"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const CampaignIcon = props => _react.default.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _react.default.createElement("path", {
  d: "M18 10.992C18 11.664 18 12.336 18 13.008H22.008V10.992H18ZM16.008 17.616C16.456 17.952 17.216 18.52 18.288 19.32L19.2 19.992L20.4 18.408L17.208 16.008L16.008 17.616ZM20.4 5.592C20.272 5.416 20.072 5.152 19.8 4.8L19.2 4.008L16.008 6.408L17.208 7.992L20.4 5.592ZM4.008 9C3.448 9 2.968 9.2 2.568 9.6C2.184 9.984 1.992 10.448 1.992 10.992V13.008C1.992 13.552 2.184 14.024 2.568 14.424C2.968 14.808 3.448 15 4.008 15H4.992V19.008H7.008V15H7.992L13.008 18V6L7.992 9H4.008ZM9.024 10.704L10.992 9.528V14.472L8.544 13.008H4.008V10.992H8.544L9.024 10.704ZM15.504 12C15.504 11.344 15.368 10.728 15.096 10.152C14.84 9.576 14.472 9.072 13.992 8.64V15.336C14.472 14.92 14.84 14.424 15.096 13.848C15.368 13.272 15.504 12.656 15.504 12Z",
  fill: "currentColor"
}));

var _default = CampaignIcon;
exports.default = _default;